import request from '@/utils/request'

// 获取报表列表
export function listReportCustom(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustom.listReportCustom',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取报表组列表
export function listReportCustomGroups(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomGroup.listReportCustomGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加报表
export function saveReportCustom(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustom.saveReportCustom',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改报表
export function updateReportCustom(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustom.updateReportCustom',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除报表
export function deleteReportCustom(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustom.deleteReportCustom',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}